const setPicturesList = data => ({
  type: "SET_PICTURES_LIST",
  data
});


export const mutation = {
  setPicturesList,
};
